export const DEFAULT_SSO_TARGET = "/segmentation-dashboard";

export const buildSsoTarget = (pathname, search = "", accountLoginSlug = null) => {
    const currentPath = pathname || "/";
    const requestedPath = `${currentPath}${search || ""}`;

    if (accountLoginSlug && currentPath.startsWith("/sso/")) {
        return DEFAULT_SSO_TARGET;
    }

    return requestedPath === "/" ? DEFAULT_SSO_TARGET : requestedPath;
};

export const buildSsoLoginUrl = ({ apiServer, provider, target, accountLoginSlug = null }) => {
    const providerKey = (provider || "").trim().toLowerCase();
    const encodedTarget = encodeURIComponent(target || DEFAULT_SSO_TARGET);

    if (providerKey === "microsoft" && accountLoginSlug) {
        return `${apiServer}/auth/oidc/account/${encodeURIComponent(accountLoginSlug)}/login?target=${encodedTarget}`;
    }

    return `${apiServer}/auth/oidc/login?provider=${encodeURIComponent(providerKey)}&target=${encodedTarget}`;
};
